import { usersAPI, ProjectType } from './../../api/projects-api';
import { handleRequestResponseError, handleServerNetworkError } from './../../utils/errorUtils/handleServerNetworkError';
import { AppRootState } from './../../app/store';
import { setAppErrorAC, setAppStatusAC } from './../../app/app-reducer';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountType } from '../Accounts/accounts-reducer';

const initialState = {
  users: [],
  accountId: 0,
  isNewAccount: false,
}

export const getUsersByAccountTC = createAsyncThunk('users/get', async (params: { accountId: number }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await usersAPI.getUsersByAccount(token, params.accountId)
    console.log('GET USERS BY ACCOUNT ID', res.data)
    thunkAPI.dispatch(setUsers({ users: res.data, accountId: params.accountId }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const createNewUserTC = createAsyncThunk('users/createNew', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  const projects = state.projects
  const userProjects: Array<string> = params.user.projects
  let projectsForBD: Array<ProjectType> = []
  userProjects.forEach(pr => {
    let i = projects.find(item => item.projectName === pr)
    if (i) {
      projectsForBD.push(i)
    }
  })
  params.user.projects = projectsForBD
  params.user.id = 0
  try {
    const res = await usersAPI.createUser(token, params.user)
    console.log('NewUser RESP', res)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `New User ${params.user.userName} with role: "${params.user.roles[0]}" was created!`, color: 'success' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const updateUserTC = createAsyncThunk('users/update', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  const projects = state.projects
  const userProjects: Array<string> = params.user.projects
  let projectsForBD: Array<ProjectType> = []
  userProjects.forEach(pr => {
    let i = projects.find(item => item.projectName === pr)
    if (i) {
      projectsForBD.push(i)
    }
  })
  params.user.projects = projectsForBD
  console.log('params.user', params.user)

  const users = state.users.users
  const userFromState = users.find(u => u.id === params.user.id)
  if (userFromState) {
    params.user.id = userFromState.id
    params.user.rowVersion = userFromState.rowVersion
  }

  try {
    const res = await usersAPI.updateUser(token, params.user)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `The user "${params.user.firstName} ${params.user.lastName}" was updated!`, color: 'success' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const updateMeTC = createAsyncThunk('me/update', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token

  try {
    const res = await usersAPI.updateMe(token, params.user)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `Your profile was updated!`, color: 'success' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const updateUsersPasswordTC = createAsyncThunk('users/updatePassword', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    await usersAPI.updateUser(token, params.user)
    thunkAPI.dispatch(getUsersByAccountTC({ accountId: params.user.accountId }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))

    thunkAPI.dispatch(setAppErrorAC({ error: `The password of user: "${params.user.firstName} ${params.user.lastName}" was updated!`, color: 'success' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const updateMyPasswordTC = createAsyncThunk('me/updatePassword', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    await usersAPI.updateMe(token, params.user)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `The password of user: "${params.user.firstName} ${params.user.lastName}" was updated!`, color: 'success' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const deleteUserTC = createAsyncThunk('user/delete', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    await usersAPI.deleteUser(token, params.user.id)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `The User ${params.user.firstName} ${params.user.lastName} was deleted!`, color: 'success' }))
  } catch (err: any) {
    handleServerNetworkError(err.message, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [err.message], fieldsErrors: '' })
  }
})

const slice = createSlice({
  name: 'usersState',
  initialState: initialState as InitialStateType,
  reducers: {
    setUsers(state, action: PayloadAction<{ users: Array<UserType>, accountId: number }>) {
      state.users = action.payload.users
      state.accountId = action.payload.accountId
    },
    setUser(state, action: PayloadAction<{ user: UserType }>) {
      let user = state.users.find(u => u.id === action.payload.user.id)
      user = action.payload.user
    },
    setIsNewAccount(state, action: PayloadAction<boolean>) {
      state.isNewAccount = action.payload
    }
  }
})

export const usersReducer = slice.reducer
export const { setUsers, setIsNewAccount, setUser } = slice.actions

export type UserType = {
  id: number
  firstName: string
  lastName: string
  userName: string
  email: string
  description: string
  isAdminRole: boolean
  roles: Array<string>
  tags: Array<string>
  isActive: boolean
  password: string
  accountId: number
  projects: Array<any>
  rowVersion: string
  account?: AccountType
}

type InitialStateType = {
  users: Array<UserType>
  accountId: number
  isNewAccount: boolean
}
